export const APP_LANGUAGES = [
  {
    value: 'PT-BR',
    label: 'Português (Brasileiro)',
    key: 'pt-BR',
    flag: 'br',
  },
  {
    value: 'EN',
    label: 'Inglês',
    key: 'en-US',
    flag: 'us',
  },
];

export const getLanguageObject = (t) => [
  {
    value: 'PT-BR',
    label: t('common.languages.pt-BR'),
    key: 'pt-BR',
    flag: 'br',
  },
  {
    value: 'EN',
    label: t('common.languages.en-US'),
    key: 'en-US',
    flag: 'us',
  },
];
